const state = {
  // 侧边栏是否折叠
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  // 设备类型
  device: 'desktop',
  // 主题颜色
  themeColor: '#409EFF'
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_THEME_COLOR: (state, color) => {
    state.themeColor = color
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setThemeColor({ commit }, color) {
    commit('SET_THEME_COLOR', color)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}